import * as core from '../../../../../../../core'
import * as prebuilt from '../../../../../../prebuilt'
import * as space from '../space'

export const RESOURCE = {
  payload: {
    alias: 'space:clusters',
    appAlias: space.RESOURCE.payload.alias,
    description: 'Clusters page',
    display: {
      isMain: false,
      position: 1,
    },
    name: 'Clusters',
    page: { id: prebuilt.Page.Id.SpaceClusters },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
